export default "__VITE_ASSET__DwofRW$F__"